import { useState } from "react";
import { ConfirmModal } from "./ConfirmModal.jsx";

export function GameTopbar({
  isHost,
  endGame,
  leaveRoom,
  trocarJogoDuranteJogo,
}) {
  const [confirmExit, setConfirmExit] = useState(false);
  const [confirmSwitch, setConfirmSwitch] = useState(false);

  return (
    <>
      <div className="game-topbar">
        {isHost && (
          <button
            onClick={() => setConfirmSwitch(true)}
            className="btn game-topbar-switch"
            type="button"
          >
            🔀 Trocar de jogo
          </button>
        )}
        <button
          onClick={() => setConfirmExit(true)}
          className="btn game-topbar-exit"
          type="button"
        >
          {isHost ? "⏹ Finalizar Jogo" : "🚪 Sair da Sala"}
        </button>
      </div>
      <ConfirmModal
        isOpen={confirmExit}
        title={isHost ? "Finalizar o jogo?" : "Sair da sala?"}
        message={
          isHost
            ? "Deseja interromper o jogo agora e ir direto para o Ranking Final? Essa ação não pode ser desfeita."
            : "Tem certeza que deseja abandonar a partida e sair da sala?"
        }
        confirmText={isHost ? "Sim, finalizar" : "Sim, sair"}
        onConfirm={() => {
          setConfirmExit(false);
          isHost ? endGame() : leaveRoom();
        }}
        onCancel={() => setConfirmExit(false)}
      />
      {isHost && (
        <ConfirmModal
          isOpen={confirmSwitch}
          title="Trocar de jogo?"
          message="Os pontos já conquistados serão mantidos e todos voltarão para a seleção de jogo."
          confirmText="Sim, trocar"
          danger={false}
          onConfirm={() => {
            setConfirmSwitch(false);
            trocarJogoDuranteJogo();
          }}
          onCancel={() => setConfirmSwitch(false)}
        />
      )}
    </>
  );
}
